import { addToTimingMap } from "owa-performance/lib/utils/timingMap";

export function addCallbackTiming(name: string): void {
    addToTimingMap("workerCallback", name);
}

export function addResponseTiming(name: string): void {
    addToTimingMap("workerResponse", name);
}
